// import React, { useState } from "react";
// import { Modal, Box, Typography, TextField, Button, IconButton } from "@mui/material";
// import ApiService from "../../../config/api";
// import CloseIcon from "@mui/icons-material/Close";

// const Download = ({ open, handleClose, onSuccess, isFormSubmitted }) => {
//     const [name, setName] = useState("");
//     const [phone, setPhone] = useState("");
//     const [errors, setErrors] = useState({});

//     const validate = () => {
//         let tempErrors = {};
//         if (!name) tempErrors.name = "Name is required";
//         if (!phone) tempErrors.phone = "Phone number is required";
//         else if (!/^\d{10}$/.test(phone)) {
//             tempErrors.phone = "Phone number must be 10 digits";
//         }
//         setErrors(tempErrors);
//         return Object.keys(tempErrors).length === 0;
//     };

//     const handleSubmit = async () => {
//         if (!validate()) return;

//         const data = {
//             name,
//             phone,
//         };

//         try {
//             await ApiService.post("/user/query", data);
//             onSuccess();
//         } catch (error) {
//             console.error("Error submitting query:", error);
//         }
//     };

//     return (
//         <Modal open={open} onClose={handleClose}>
//             <Box sx={modalStyle}>
//                 <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
//                     <Typography variant="h6" gutterBottom>
//                         Download Brochure
//                     </Typography>
//                     <IconButton
//                         aria-label="close"
//                         onClick={handleClose}
//                         sx={{ color: "var(--bs-primary)" }}
//                     >
//                         <CloseIcon />
//                     </IconButton>
//                 </Box>

//                 <Typography variant="body2" sx={{ mb: 2 }}>
//                     Please fill in your details to download the brochure.
//                 </Typography>

//                 <TextField
//                     fullWidth
//                     label="Name *"
//                     variant="outlined"
//                     value={name}
//                     onChange={(e) => setName(e.target.value)}
//                     error={Boolean(errors.name)}
//                     helperText={errors.name}
//                     sx={{ marginBottom: 2 }}
//                 />
//                 <TextField
//                     fullWidth
//                     label="Phone *"
//                     variant="outlined"
//                     value={phone}
//                     onChange={(e) => setPhone(e.target.value)}
//                     error={Boolean(errors.phone)}
//                     helperText={errors.phone}
//                     sx={{ marginBottom: 2 }}
//                 />
//                 <Button
//                     variant="contained"
//                     onClick={handleSubmit}
//                     sx={{
//                         backgroundColor: "var(--bs-primary)",
//                         "&:hover": { backgroundColor: "var(--bs-accent)" },
//                     }}
//                 >
//                     Submit
//                 </Button>
//             </Box>
//         </Modal>
//     );
// };

// const modalStyle = {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     width: 400,
//     bgcolor: "var(--bs-secondary)",
//     boxShadow: 24,
//     p: 3,
//     borderRadius: 2,
//     color: "var(--bs-primary)",
// };

// export default Download;

import React, { useState } from "react";
import {
    Modal,
    Box,
    Typography,
    TextField,
    Button,
    IconButton,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from "@mui/material";
import ApiService from "../../../config/api";
import CloseIcon from "@mui/icons-material/Close";

const Download = ({ open, handleClose, onSuccess }) => {
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");

    const [budgetRange, setBudgetRange] = useState("");
    const [purposeOfPurchase, setPurposeOfPurchase] = useState("");
    const [timelineToPurchase, setTimelineToPurchase] = useState("");
    const [siteVisitPreference, setSiteVisitPreference] = useState("");

    const [errors, setErrors] = useState({});

    const validate = () => {
        let temp = {};

        if (!name) temp.name = "Required";
        if (!phone) temp.phone = "Required";
        else if (!/^\d{10}$/.test(phone)) temp.phone = "10 digits only";

        if (!budgetRange) temp.budgetRange = "Required";
        if (!purposeOfPurchase) temp.purposeOfPurchase = "Required";
        if (!timelineToPurchase) temp.timelineToPurchase = "Required";
        if (!siteVisitPreference) temp.siteVisitPreference = "Required";

        setErrors(temp);
        return Object.keys(temp).length === 0;
    };

    const handleSubmit = async () => {
        if (!validate()) return;

        const data = {
            name,
            phone,
            budgetRange,
            purposeOfPurchase,
            timelineToPurchase,
            siteVisitPreference,
        };

        try {
            await ApiService.post("/user/query", data);
            setName("");
            setPhone("");
            setBudgetRange("");
            setPurposeOfPurchase("");
            setTimelineToPurchase("");
            setSiteVisitPreference("");
            onSuccess();
        } catch (error) {
            console.error("Error:", error);
        }
    };

    return (
        <Modal open={open} onClose={handleClose}>
            <Box sx={modalStyle}>

                {/* Header */}
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                    <Typography variant="h6" sx={{ fontSize: "16px", fontWeight: 600 }}>
                        Download Brochure
                    </Typography>
                    <IconButton onClick={handleClose} sx={{ color: "var(--bs-primary)" }}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </Box>

                <Typography sx={{ mb: 2, fontSize: "13px", color: "#666" }}>
                    Fill your details to download the brochure.
                </Typography>

                {/* Name */}
                <TextField
                    fullWidth
                    size="small"
                    label="Name *"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    error={!!errors.name}
                    helperText={errors.name}
                    sx={{ mb: 2 }}
                />

                {/* Phone */}
                <TextField
                    fullWidth
                    size="small"
                    label="Phone *"
                    value={phone}
                    onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, ""); // allow only numbers
                        if (value.length <= 10) setPhone(value);
                    }}
                    inputProps={{ maxLength: 10 }}
                    error={!!errors.phone}
                    helperText={errors.phone}
                    sx={{ mb: 2 }}
                />


                {/* Dropdown Styles */}
                <style>
                    {`
                    .dropdown-label {
                        font-size: 13px;
                    }
                    .dropdown-menu-item {
                        font-size: 13px;
                    }
                    `}
                </style>

                {/* Budget Range */}
                <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                    <InputLabel className="dropdown-label">Budget Range *</InputLabel>
                    <Select
                        value={budgetRange}
                        label="Budget Range *"
                        onChange={(e) => setBudgetRange(e.target.value)}
                        error={!!errors.budgetRange}
                    >
                        <MenuItem value="Below ₹25 Lakhs" className="dropdown-menu-item">Below ₹25 Lakhs</MenuItem>
                        <MenuItem value="₹25 –  50 Lakhs" className="dropdown-menu-item">₹25 –  50 Lakhs</MenuItem>
                        <MenuItem value="₹50 Lakhs – 1 Cr" className="dropdown-menu-item">₹50 Lakhs – 1 Cr</MenuItem>
                        <MenuItem value="₹1 – 3 Cr" className="dropdown-menu-item">₹1 – 3 Cr</MenuItem>
                        <MenuItem value="Above ₹3 Cr" className="dropdown-menu-item">Above ₹3 Cr</MenuItem>
                    </Select>
                    {errors.budgetRange && <small style={{ color: "red", fontSize: "12px" }}>{errors.budgetRange}</small>}
                </FormControl>

                {/* Purpose of Purchase */}
                <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                    <InputLabel className="dropdown-label">Purpose of Purchase *</InputLabel>
                    <Select
                        value={purposeOfPurchase}
                        label="Purpose of Purchase *"
                        onChange={(e) => setPurposeOfPurchase(e.target.value)}
                        error={!!errors.purposeOfPurchase}
                    >
                        <MenuItem value="Self-use" className="dropdown-menu-item">Self-use</MenuItem>
                        <MenuItem value="Investment" className="dropdown-menu-item">Investment</MenuItem>
                        <MenuItem value="Rental Income" className="dropdown-menu-item">Rental Income</MenuItem>
                    </Select>
                    {errors.purposeOfPurchase && <small style={{ color: "red", fontSize: "12px" }}>{errors.purposeOfPurchase}</small>}
                </FormControl>

                {/* Timeline */}
                <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                    <InputLabel className="dropdown-label">Timeline *</InputLabel>
                    <Select
                        value={timelineToPurchase}
                        label="Timeline *"
                        onChange={(e) => setTimelineToPurchase(e.target.value)}
                        error={!!errors.timelineToPurchase}
                    >
                        <MenuItem value="Immediate (0–1 month)" className="dropdown-menu-item">Immediate (0–1 month)</MenuItem>
                        <MenuItem value="1–3 months" className="dropdown-menu-item">1–3 months</MenuItem>
                        <MenuItem value="3–6 months" className="dropdown-menu-item">3–6 months</MenuItem>
                        <MenuItem value="Just exploring" className="dropdown-menu-item">Just exploring</MenuItem>
                    </Select>
                    {errors.timelineToPurchase && <small style={{ color: "red", fontSize: "12px" }}>{errors.timelineToPurchase}</small>}
                </FormControl>

                {/* Visit Preference */}
                <FormControl fullWidth size="small" sx={{ mb: 3 }}>
                    <InputLabel className="dropdown-label">Site Visit Preference *</InputLabel>
                    <Select
                        value={siteVisitPreference}
                        label="Site Visit Preference *"
                        onChange={(e) => setSiteVisitPreference(e.target.value)}
                        error={!!errors.siteVisitPreference}
                    >
                        <MenuItem value="Weekdays" className="dropdown-menu-item">Weekdays</MenuItem>
                        <MenuItem value="Weekends" className="dropdown-menu-item">Weekends</MenuItem>
                        <MenuItem value="Flexible" className="dropdown-menu-item">Flexible</MenuItem>
                    </Select>
                    {errors.siteVisitPreference && (
                        <small style={{ color: "red", fontSize: "12px" }}>{errors.siteVisitPreference}</small>
                    )}
                </FormControl>

                {/* Submit */}
                <Button
                    fullWidth
                    variant="contained"
                    onClick={handleSubmit}
                    sx={{
                        backgroundColor: "var(--bs-primary)",
                        fontSize: "14px",
                        py: "6px",
                        "&:hover": { backgroundColor: "var(--bs-accent)" },
                    }}
                >
                    Submit
                </Button>
            </Box>
        </Modal>
    );
};

const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",         // Mobile responsive
    maxWidth: 420,        // Desktop size
    bgcolor: "var(--bs-secondary)",
    boxShadow: 24,
    p: 2,
    borderRadius: 2,
};

export default Download;
